module.exports = __webpack_public_path__ + "static/assets/8f5825c2f04d90933f0a23a9cac21487.png";